<section class="container-fluid fondo-negro">
    <section class="container ">
        <div class="row  pt-5 pb-5">
            <div class="col-6" *ngIf="eventos.length > 0">
                <h3>EVENTO:</h3>
                <hr class="linea-blanca">

                <img src="{{eventos[0].imagen.url}}" class="img-100" alt="">
                <button class="boton-leer rounded-pill" routerLink="/eventos/evento/{{eventos[0].id}}">LEER MÁS</button>
                <h4>COMING SOON</h4>
                <p class="titulo"><strong>{{eventos[0].artistas}} - {{eventos[0].nombre}} / {{eventos[0].ciudadNombre}}
                        - Colombia</strong></p>

                <div>
                    <div class="contenedor">
                        <div>
                            <div class="numeros">
                                <p> {{time.days}} </p>
                            </div>
                            <p class="menos">DAY(S)</p>
                        </div>
                        <div>
                            <div class="numeros">
                                <p> {{time.hours}} </p>
                            </div>
                            <p class="menos">HOUR</p>
                        </div>
                        <div>
                            <div class="numeros">
                                <p> {{time.minutes}} </p>
                            </div>
                            <p class="menos">MINUTE</p>
                        </div>
                        <div>
                            <div class="numeros">
                                <p> {{time.seconds}} </p>
                            </div>
                            <p class="menos">SECOND</p>
                        </div>
                    </div>
                    <div class="caja-boton">
                        <button class="rounded-pill" routerLink="/eventos/evento/{{eventos[0].id}}">COMPRAR</button>
                    </div>
                </div>
            </div>
            <div class="col-6 blanco">
                <h3 class="pt-4 pl-1">PRÓXIMOS EVENTOS</h3>
                <hr class="linea-negra">

                    <div class="cien" *ngFor="let evento of eventos">
                      <div class="flotar">
                          <img src="{{evento.imagen.url}}"  class="img-100" alt="">
                          <button class="comprar-l" routerLink="/eventos/evento/{{evento.id}}">COMPRAR</button>
                      </div>  
                      <div class="flotar">
                          <p class="negro-titulo" routerLink="/eventos/evento/{{evento.id}}"><strong> {{evento.nombre}}</strong></p>
                          <p class="lugar">{{evento.lugar}} / {{evento.ciudadNombre}}</p>
                          <p class="fecha">{{darFecha(evento)}}</p>
                          <p class="member">MEMBER FRAT CLUB GOLD</p>
                      </div>
                      <div class="clearFix"></div>
                      <div class="cien">
                      <hr class="linea-negra-2">
                    </div>
                    <div class="clearFix"></div>
                    </div>

                
            </div>
        </div>

    </section>
</section>